export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/wss.worker.b5f6e687.worker.js");
}
